import { WhoIsThisFormOption } from 'pages/sales-portal/SalesPortalBillingPlan/components/Checkout/CheckoutContext';
import { ProfileRetrieve, Session } from 'types';
import { isEmpty } from 'utils/functions';

export function calculateEmail(
  whoIsThisFor: WhoIsThisFormOption,
  session: Session | null,
  profileId: string | undefined,
  subAccountProfiles: ProfileRetrieve[],
): string {
  if (whoIsThisFor === 'myself' || whoIsThisFor === 'newDependentAccount') {
    return session?.user.email ?? '';
  }

  if (whoIsThisFor === 'subAccount' && profileId) {
    return subAccountProfiles.find(profile => profile.profileId === profileId)?.userEmail ?? '';
  }

  return '';
}

export function calculateFullName(
  session: Session | null,
  ownAthleteProfile: ProfileRetrieve | undefined,
): string {
  const athleteFullName = ownAthleteProfile?.fullName;
  const userFullName = `${session?.user.firstName ?? ''} ${session?.user.lastName ?? ''}`.trim();
  const fullName = !isEmpty(athleteFullName) ? athleteFullName : userFullName;
  return fullName ?? '';
}

export function calculateMyselfLabel(
  session: Session | null,
  ownAthleteProfile: ProfileRetrieve | undefined,
): string {
  const fullName = calculateFullName(session, ownAthleteProfile);
  return fullName ? `${fullName} (Myself)` : 'Myself';
}
